// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"80597e7b","277":"80597e7b","568":"4408977a","712":"a15af783","804":"d933ebc1","810":"3460ebd5","872":"770f7c85"}[chunkId] + ".chunk.css";
};